export default {
    canBeStretched: true,
    styleCanBeApplied: true,

    mobileConversionConfig: {
        preserveAspectRatio: false
    }
}
